import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';

@Pipe({
    name: 'dayjs',
    standalone: true,
    pure: true,
})
export class DayjsPipe implements PipeTransform {
    transform(value: Date | string | number | null | undefined, format = 'DD/MM/YYYY'): string {
        if (value == null) return '';
        return dayjs(value).format(format);
    }
}
